import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Switch } from 'react-native-paper';
import { Colors } from '../constants';
import { TextReg } from './StyledText';

type Props = {
  value: boolean;
  onValueChange: (value: boolean) => void;
  leftLabel?: string;
  rightLabel?: string;
  disabled?: boolean;
};

export function Toggle({
  value,
  onValueChange,
  leftLabel,
  rightLabel,
  disabled = false,
}: Props) {
  return (
    <View style={styles.container}>
      {leftLabel && (
        <TextReg
          style={[styles.label, styles.leftLabel, !value && styles.activeLabel]}
        >
          {leftLabel}
        </TextReg>
      )}
      <Switch
        value={value}
        onValueChange={onValueChange}
        disabled={disabled}
        thumbColor={value ? Colors.purple0 : Colors.text}
        trackColor={{
          false: Colors.opacity20,
          true: Colors.purple1,
        }}
        style={styles.switch}
      />
      {rightLabel && (
        <TextReg
          style={[styles.label, styles.rightLabel, value && styles.activeLabel]}
        >
          {rightLabel}
        </TextReg>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  switch: {
    transform: [{ scaleX: 0.8 }, { scaleY: 0.8 }],
  },
  label: {
    fontSize: 12,
    fontWeight: '500',
    color: Colors.text,
    opacity: 0.7,
  },
  leftLabel: {
    textAlign: 'right',
  },
  rightLabel: {
    textAlign: 'left',
  },
  activeLabel: {
    opacity: 1,
    color: Colors.purple1,
    fontWeight: '600',
  },
});
